// Where to land after sign-in when a signed-out visitor started from a deep link
// (coach / grove invite). The ?returnTo= param carries it through email and OAuth
// round trips; this localStorage copy is the fallback for paths that drop the param
// (a magic link opened in another tab, an OAuth return that lands on /today).
const KEY = 'gt_return_to'
const TTL_MS = 60 * 60 * 1000

// Same-origin relative paths only: "//host" and "/\host" are protocol-relative to
// browsers, and they strip tabs/newlines before parsing.
export function safeReturnTo(path: unknown): string | undefined {
  if (typeof path !== 'string' || !path.startsWith('/')) return undefined
  if (path.startsWith('//') || path.includes('\\')) return undefined
  if ([...path].some((c) => c.charCodeAt(0) < 0x20)) return undefined
  return path
}

export function stashReturnTo(path: string) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }))
  } catch {}
}

export function peekReturnTo(): string | undefined {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return undefined
    const { path, at } = JSON.parse(raw) as { path?: unknown; at?: number }
    if (typeof at === 'number' && Date.now() - at < TTL_MS) return safeReturnTo(path)
    localStorage.removeItem(KEY)
  } catch {}
  return undefined
}

export function clearReturnTo() {
  try {
    localStorage.removeItem(KEY)
  } catch {}
}

// Consumes the stash either way so it can't redirect a later sign-in.
export function takeReturnTo(explicit?: string): string | undefined {
  const stashed = peekReturnTo()
  clearReturnTo()
  return explicit ?? stashed
}
